import React, { Component, RefObject } from 'react';
import { WithStyles, createStyles, withStyles } from '@material-ui/core/styles';

import { Message } from '../../../modules/tracelog';

const styles = () => createStyles({
    root: {
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        overflow: 'auto',
    },
    codeBlock: {
        display: 'inline-block',
        textAlign: 'left',
    },
})

class RawViewer extends Component<Props> {
    contentRef = React.createRef<HTMLElement>();

    componentDidMount() {
        this.props.contentConsumer(this.contentRef);
    }
    render() {
        const { message, classes } = this.props;

        return (
            <div style={{ height: '100%', overflow: 'auto' }}>
                <pre className={classes.codeBlock} style={{ margin: 0, paddingBottom: '5rem' }}>
                    <code ref={this.contentRef}>{message.body}</code>
                </pre>
            </div>
        )
    }
}

interface Props extends WithStyles<typeof styles> {
    contentConsumer(ref: RefObject<HTMLElement>): void
    message: Message
}

export default withStyles(styles)(RawViewer);